import React, { createContext, useContext, useState, useEffect } from "react";

const LangContext = createContext(null);

const T = {
  it: {
    // Common
    products: "Prodotti", categories: "Categorie", agents: "Agenti", pricelists: "Tipi Listino",
    generator: "Genera Listino", code: "Codice", description: "Descrizione", price: "Prezzo",
    basePrice: "Prezzo Base", availability: "Disp.", available: "Disponibile",
    week: "Settimana", year: "Anno", search: "Cerca...", save: "Salva", cancel: "Annulla",
    download: "Scarica", language: "Lingua", columns: "Colonne", show: "Mostra", hide: "Nascondi",
    name: "Nome", nameEn: "Nome (EN)", descEn: "Descrizione (EN)", order: "Ordine",
    login: "Accedi", logout: "Esci", new: "Nuovo", edit: "Modifica", delete: "Elimina",
    import: "Importa", generatePdf: "Genera PDF",
    company: "Azienda", changeCompany: "Cambia azienda", dashboard: "Dashboard",
    orders: "Ordini", customers: "Clienti", suppliers: "Fornitori", offers: "Offerte",
    supplierOrders: "Ord. Fornitori", statsProducts: "Stats prodotti",
    pendingApproval: "Da approvare", chat: "Chat", warehouse: "Magazzino",
    customer: "Cliente", admin: "Amministratore", agent: "Agente",
    total: "Totale", subtotal: "Imponibile", vat: "IVA", quantity: "Quantità", unit: "U.M.",
    status: "Stato", actions: "Azioni", details: "Dettaglio", preview: "Anteprima",
    addItem: "Aggiungi articolo", outOfListino: "Fuori Listino", inListino: "In Listino",
    confirm: "Conferma", yes: "Sì", no: "No", close: "Chiudi", back: "Indietro",
    loading: "Caricamento...", noResults: "Nessun risultato",
    statusPending: "Da preparare", statusInPrep: "In preparazione", statusReady: "Pronto",
    statusShipped: "Spedito", statusDelivered: "Consegnato", statusCancelled: "Annullato",
    statusPendingAgent: "Da approvare", statusCompleted: "Completato", statusPaid: "Pagato",
    statusConfirmed: "Confermato",
    itemsCol: "Articoli",
    newOrder: "Nuovo ordine",
    // BI dashboard
    biTitle: "Business Intelligence",
    biSubtitle: "Andamento ordini, spedizioni, fatturato e provvigioni",
    biKpiOrders: "Ordini totali", biKpiTaxable: "Imponibile", biKpiShipped: "Spediti — Valore",
    biKpiCommissions: "Provvigioni totali",
    biKpiShippedDesc: "spediti · in attesa", biKpiTaxableDesc: "Totale IVA inc.",
    biKpiConfirmedDesc: "confermati e usciti", biKpiCommissionsDesc: "da liquidare/maturate",
    biDailyTrend: "Andamento giornaliero",
    biTopCustomers: "Top clienti per fatturato",
    biTopAgents: "Agenti",
    biTopProducts: "Top prodotti spediti (per quantità)",
    biDailyDetail: "Dettaglio giornaliero",
    biColDay: "Giorno", biColOrders: "Ordini", biColTaxable: "Imponibile",
    biColVat: "IVA", biColTotal: "Totale", biColCommission: "Provv.",
    biPeriodThisMonth: "Questo mese", biPeriodLast30: "Ultimi 30 giorni",
    biPeriodLast7: "Ultimi 7 giorni", biPeriodToday: "Oggi", biPeriodAll: "Tutto",
    // Products page
    allProducts: "Tutti i prodotti", allCategories: "Tutte le categorie",
    onlyInListino: "Solo In Listino", onlyOutOfListino: "Solo Fuori Listino",
    category: "Categoria", note: "Note", importExcel: "Importa da Excel",
    uploadFile: "Carica file Excel (.xlsx)", finalPrice: "Prezzo Finale",
    noAgents: "Nessun agente creato", noPricelistType: "Nessun tipo listino configurato",
    edit: "Modifica", deleteProduct: "Elimina prodotto",
    // Orders
    ordersList: "Ordini", customerCol: "Cliente", agentCol: "Agente",
    dateCol: "Data", totalCol: "Totale",
    // Login / form
    email: "Email", password: "Password", emailPh: "tua@email.com",
    selectRole: "Scegli il tuo ruolo",
    welcome: "Benvenuto",
    // Misc
    address: "Indirizzo", phone: "Telefono", contact: "Contatto",
    vatNumber: "P. IVA", taxCode: "Codice Fiscale",
    accessCode: "Codice Accesso", commission: "Provvigione",
    markup: "Ricarico", discount: "Sconto",
    free: "Gratis", italian: "Italiano", foreign: "Estero",
    submit: "Invia", create: "Crea", update: "Aggiorna",
    none: "Nessuno", all: "Tutti", active: "Attivo", inactive: "Inattivo",
    type: "Tipo",
    // Currency / settings
    companySettings: "Impostazioni azienda",
    currencyAndExchange: "Valuta e cambio",
    currency: "Valuta", symbol: "Simbolo",
    exchangeRate: "Cambio manuale",
    exchangeRateHint: "Imposta a mano per evitare fluttuazioni del cambio reale",
    displayInEur: "Mostra prezzi in EUR",
    displayInEurHint: "Conversione UI usando il cambio impostato. I prezzi nel DB restano in valuta locale.",
    preview: "Anteprima",
    // Portals - common
    backToOrders: "Torna agli ordini",
    profile: "Profilo",
    settings: "Impostazioni",
    notifications: "Notifiche",
    welcome2: "Bentornato",
    overview: "Panoramica",
    recentOrders: "Ordini recenti",
    catalog: "Catalogo",
    cart: "Carrello",
    yourOrders: "I tuoi ordini",
    profile2: "Profilo",
    repeat: "Ripeti",
    partial: "Parziale",
    // Customer specific
    deliveryAddress: "Indirizzo consegna",
    deliveryNotes: "Note consegna",
    specialRequests: "Richieste speciali",
    addToCart: "Aggiungi al carrello",
    placeOrder: "Invia ordine",
    cartEmpty: "Il carrello è vuoto",
    productAdded: "Prodotto aggiunto al carrello",
    // Warehouse specific
    toPrepare: "Da preparare",
    inProgress: "In lavorazione",
    documentReference: "Riferimento DDT",
    weight: "Peso",
    actualQuantity: "Quantità reale",
    markReady: "Marca come pronto",
    markShipped: "Spedito",
    markDelivered: "Consegnato",
    startPrep: "Inizia preparazione",
    // Agent specific
    myCustomers: "I miei clienti",
    myOrders: "I miei ordini",
    commissionTotal: "Provvigione totale",
    pendingApprovals: "Approvazioni pendenti",
    approve: "Approva",
    reject: "Rifiuta",
    // Chat
    typeMessage: "Scrivi un messaggio...",
    send: "Invia",
    newChat: "Nuova chat",
    noChats: "Nessuna chat",
    sentBy: "Inviato da",
    // Portal — Agent
    pAgent_overview: "Panoramica",
    pAgent_kpiOrdersTotal: "Ordini totali",
    pAgent_kpiCommissionPending: "Provv. in attesa",
    pAgent_kpiCommissionEarned: "Maturata (spedita)",
    pAgent_kpiCommissionCollected: "Incassata (saldata)",
    pAgent_kpiCommissionEarnedSub: "su ordini spediti/consegnati",
    pAgent_kpiCommissionCollectedSub: "ordini saldati dal cliente",
    pAgent_monthOrders: "Ordini mese",
    pAgent_monthRevenueSub: "fatturato",
    pAgent_kpiTotalRevenue: "Fatturato complessivo",
    pAgent_subTotalPending: "ordini ancora da spedire",
    pAgent_lastOrders: "Ultimi ordini",
    pAgent_newOrder: "Nuovo ordine",
    pAgent_approvals: "Approvazioni",
    pAgent_customersList: "Clienti",
    pAgent_orderDetail: "Dettaglio ordine",
    pAgent_unitPrice: "Prezzo unitario",
    pAgent_lineTotal: "Totale riga",
    pAgent_estimatedTotal: "Totale stimato",
    pAgent_finalTotal: "Totale finale",
    pAgent_commissionLine: "Provvigione",
    pAgent_review: "Rivedi e conferma",
    pAgent_confirmSend: "Conferma e invia",
    pAgent_sending: "Invio...",
    pAgent_emptyCart: "Carrello vuoto",
    // Portal — Customer
    pCust_yourOrders: "I tuoi ordini",
    pCust_yourCart: "Il tuo carrello",
    pCust_proceedCheckout: "Procedi al checkout",
    pCust_orderConfirmed: "Ordine inviato",
    pCust_continueShopping: "Continua acquisti",
    pCust_repeatOrder: "Ripeti ordine",
    pCust_orderNumber: "N° ordine",
    pCust_orderDate: "Data",
    pCust_orderTotal: "Totale",
    pCust_emptyOrders: "Nessun ordine effettuato",
    // Portal — Warehouse
    pWh_toPrepare: "Da preparare",
    pWh_inPreparation: "In preparazione",
    pWh_ready: "Pronti",
    pWh_shipped: "Spediti",
    pWh_kpiOrdersToday: "Ordini oggi",
    pWh_kpiToPrepareCount: "Da preparare",
    pWh_kpiReadyCount: "Pronti",
    pWh_kpiShippedCount: "Spediti",
    pWh_documentRef: "Riferimento DDT",
    pWh_actualWeight: "Peso reale",
    pWh_missingItem: "Mancante",
    pWh_substitute: "Sostituisci",
    pWh_scanDDT: "Scansiona DDT",
    pWh_orderNumber: "Ordine n.",
    pWh_customer: "Cliente",
    pWh_save: "Salva",
    pWh_markReady: "Marca come pronto",
    pWh_markShipped: "Marca come spedito",
    pWh_proposeNew: "Proponi nuovo prodotto",
    pWh_extraItem: "Prodotto extra",
    pWh_stats: "Statistiche",
    pWh_emptyToPrepare: "Nessun ordine da preparare",
    pWh_emptyReady: "Nessun ordine pronto",
    pWh_emptyShipped: "Nessun ordine spedito oggi",
    pWh_searchOrder: "Cerca ordine, cliente, agente...",
    pWh_filterStatus: "Filtra per stato",
    pWh_filterAll: "Tutti gli ordini",
    pWh_filterAgent: "Filtra per agente",
    pWh_filterCustomer: "Filtra per cliente",
    pWh_orderHeader: "Ordini da preparare",
    pWh_offerCreate: "Nuova offerta",
    pWh_suppliers: "Fornitori",
    pWh_supplierOrders: "Ordini fornitori",
    pWh_newSupplierOrder: "Nuovo ordine fornitore",
    pWh_stockLow: "Scorte basse",
    pWh_addExtra: "Aggiungi extra",
    pWh_substituteWith: "Sostituisci con",
    pWh_actualQty: "Q.tà reale",
    pWh_originalQty: "Q.tà richiesta",
    pWh_noteForOrder: "Note per ordine",
    pWh_qualityNote: "Note qualità",
    // Agent — internal pages
    pAgent_anagraficaClienti: "Anagrafica Clienti",
    pAgent_nClienti: "{n} clienti",
    pAgent_newCustomer: "Nuovo cliente",
    pAgent_editCustomer: "Modifica cliente",
    pAgent_searchCustomer: "Cerca per ragione sociale, P.IVA, codice...",
    pAgent_emptyCustomers: "Nessun cliente — clicca \"Nuovo cliente\" per iniziare",
    pAgent_orderHistory: "Storico ordini",
    pAgent_pendingApprovals: "Da approvare",
    pAgent_offers: "Offerte speciali",
    pAgent_selectCustomer: "Seleziona un cliente",
    pAgent_addProduct: "Aggiungi prodotto",
    pAgent_addedToCart: "Aggiunto",
    pAgent_noProductFound: "Nessun prodotto",
    pAgent_searchProduct: "Cerca per codice o descrizione...",
    pAgent_specialRequests: "Richieste speciali",
    pAgent_deliveryDate: "Data consegna",
    pAgent_deliveryNotes: "Note consegna",
    pAgent_orderSent: "Ordine inviato",
    pAgent_orderApproved: "Ordine approvato",
    pAgent_orderRejected: "Ordine rifiutato",
    pAgent_loadError: "Errore caricamento",
    pAgent_saveError: "Errore salvataggio",
    pAgent_loginCreated: "Login creato",
    pAgent_passwordReset: "Password aggiornata",
    pAgent_passwordTooShort: "Password troppo corta",
    pAgent_credentialsCopied: "Credenziali copiate",
    pAgent_resetPassword: "Reimposta password",
    pAgent_legalSeat: "Sede legale",
    pAgent_clearCart: "Pulisci",
    pAgent_emptyCart: "Carrello vuoto",
    pAgent_items: "Articoli",
    pAgent_seeProductDetail: "Vedi dettagli prodotto",
    // Customer — internal pages
    pCust_orderHistory: "Storico ordini",
    pCust_emptyCart: "Carrello vuoto",
    pCust_addedToCart: "Aggiunto al carrello",
    pCust_clearCart: "Svuota carrello",
    pCust_sendOrder: "Invia ordine",
    pCust_orderSent: "Ordine inviato",
    pCust_loadError: "Errore caricamento",
    pCust_specialRequests: "Richieste speciali",
    pCust_deliveryDate: "Data consegna",
    pCust_deliveryNotes: "Note consegna",
    pCust_searchProduct: "Cerca prodotti...",
    pCust_filterCategory: "Categoria",
    pCust_unitPrice: "Prezzo unitario",
    pCust_total: "Totale",
    pCust_orderNumber: "Ordine n.",
    pCust_status: "Stato",
    // Common (extra)
    common_save: "Salva",
    common_cancel: "Annulla",
    common_delete: "Elimina",
    common_edit: "Modifica",
    common_close: "Chiudi",
    common_add: "Aggiungi",
    common_back: "Indietro",
    common_next: "Avanti",
    common_confirm: "Conferma",
    common_search: "Cerca",
    common_loading: "Caricamento...",
    common_saving: "Salvataggio...",
    common_sending: "Invio...",
    common_yes: "Sì",
    common_no: "No",
    common_error: "Errore",
    common_success: "Operazione completata",
    common_required: "Campo obbligatorio",
    common_notFound: "Non trovato",
    common_unknown: "Sconosciuto",
    // Settings
    settings: "Impostazioni",
    settingsGeneral: "Dati Aziendali",
    settingsCurrency: "Valuta e Cambio",
    settingsPreview: "Anteprima",
    settingsSaved: "Impostazioni salvate",
    settingsSaveError: "Errore salvataggio",
    companyName: "Nome azienda",
    country: "Paese (codice)",
    vatNumber: "Partita IVA / VAT",
    defaultLang: "Lingua predefinita",
    address: "Indirizzo",
    currencyCode: "Codice valuta",
    currencySymbol: "Simbolo",
    exchangeRate: "Cambio verso EUR",
    exchangeRateHint: "Es: 1 EUR = 4.30 PLN → inserisci 4.30. Imposta 1.0 se la valuta è EUR.",
    defaultVatRate: "IVA predefinita (es. 0.10 = 10%)",
    priceExample: "Prezzo esempio (100)",
    convertedToEUR: "Convertito in EUR",
    exampleVat: "IVA su 100",
    displayCurrencyMode: "Modalità calcolo / visualizzazione",
    nativeCurrency: "Valuta nativa",
    nativeCurrencyHint: "Tutti i calcoli e i totali sono nella valuta dell'azienda",
    eurCurrency: "Euro (convertito)",
    eurCurrencyHint: "Converti tutto in EUR usando il cambio impostato",
    alreadyEur: "Azienda già in EUR",
  },
  en: {
    products: "Products", categories: "Categories", agents: "Agents", pricelists: "Pricelist Types",
    generator: "Generate Pricelist", code: "Code", description: "Description", price: "Price",
    basePrice: "Base Price", availability: "Avail.", available: "Available",
    week: "Week", year: "Year", search: "Search...", save: "Save", cancel: "Cancel",
    download: "Download", language: "Language", columns: "Columns", show: "Show", hide: "Hide",
    name: "Name", nameEn: "Name (EN)", descEn: "Description (EN)", order: "Order",
    login: "Login", logout: "Logout", new: "New", edit: "Edit", delete: "Delete",
    import: "Import", generatePdf: "Generate PDF",
    company: "Company", changeCompany: "Switch company", dashboard: "Dashboard",
    orders: "Orders", customers: "Customers", suppliers: "Suppliers", offers: "Offers",
    supplierOrders: "Supplier Orders", statsProducts: "Product Stats",
    pendingApproval: "To approve", chat: "Chat", warehouse: "Warehouse",
    customer: "Customer", admin: "Administrator", agent: "Agent",
    total: "Total", subtotal: "Subtotal", vat: "VAT", quantity: "Quantity", unit: "Unit",
    status: "Status", actions: "Actions", details: "Detail", preview: "Preview",
    addItem: "Add item", outOfListino: "Off-catalog", inListino: "On Catalog",
    confirm: "Confirm", yes: "Yes", no: "No", close: "Close", back: "Back",
    loading: "Loading...", noResults: "No results",
    statusPending: "To prepare", statusInPrep: "In preparation", statusReady: "Ready",
    statusShipped: "Shipped", statusDelivered: "Delivered", statusCancelled: "Cancelled",
    statusPendingAgent: "Awaiting approval", statusCompleted: "Completed", statusPaid: "Paid",
    statusConfirmed: "Confirmed",
    itemsCol: "Items",
    newOrder: "New order",
    biTitle: "Business Intelligence",
    biSubtitle: "Orders, shipments, revenue and commissions overview",
    biKpiOrders: "Total orders", biKpiTaxable: "Taxable", biKpiShipped: "Shipped — Value",
    biKpiCommissions: "Total commissions",
    biKpiShippedDesc: "shipped · pending", biKpiTaxableDesc: "VAT incl.",
    biKpiConfirmedDesc: "confirmed and shipped", biKpiCommissionsDesc: "to settle/earned",
    biDailyTrend: "Daily trend",
    biTopCustomers: "Top customers by revenue",
    biTopAgents: "Agents",
    biTopProducts: "Top shipped products (by quantity)",
    biDailyDetail: "Daily detail",
    biColDay: "Day", biColOrders: "Orders", biColTaxable: "Taxable",
    biColVat: "VAT", biColTotal: "Total", biColCommission: "Comm.",
    biPeriodThisMonth: "This month", biPeriodLast30: "Last 30 days",
    biPeriodLast7: "Last 7 days", biPeriodToday: "Today", biPeriodAll: "All",
    allProducts: "All products", allCategories: "All categories",
    onlyInListino: "Only In Catalog", onlyOutOfListino: "Only Off-catalog",
    category: "Category", note: "Note", importExcel: "Import from Excel",
    uploadFile: "Upload Excel file (.xlsx)", finalPrice: "Final price",
    noAgents: "No agents created", noPricelistType: "No pricelist type configured",
    deleteProduct: "Delete product",
    ordersList: "Orders", customerCol: "Customer", agentCol: "Agent",
    dateCol: "Date", totalCol: "Total",
    email: "Email", password: "Password", emailPh: "your@email.com",
    selectRole: "Choose your role", welcome: "Welcome",
    address: "Address", phone: "Phone", contact: "Contact",
    vatNumber: "VAT number", taxCode: "Tax code",
    accessCode: "Access code", commission: "Commission",
    markup: "Markup", discount: "Discount",
    free: "Free", italian: "Italian", foreign: "Foreign",
    submit: "Submit", create: "Create", update: "Update",
    none: "None", all: "All", active: "Active", inactive: "Inactive",
    type: "Type",
    companySettings: "Company settings",
    currencyAndExchange: "Currency & exchange rate",
    currency: "Currency", symbol: "Symbol",
    exchangeRate: "Manual exchange rate",
    exchangeRateHint: "Set manually to avoid live FX fluctuations",
    displayInEur: "Show prices in EUR",
    displayInEurHint: "UI-only conversion using the set rate. Prices in DB stay in native currency.",
    preview: "Preview",
    backToOrders: "Back to orders",
    profile: "Profile",
    settings: "Settings",
    notifications: "Notifications",
    welcome2: "Welcome back",
    overview: "Overview",
    recentOrders: "Recent orders",
    catalog: "Catalog",
    cart: "Cart",
    yourOrders: "Your orders",
    profile2: "Profile",
    repeat: "Repeat",
    partial: "Partial",
    deliveryAddress: "Delivery address",
    deliveryNotes: "Delivery notes",
    specialRequests: "Special requests",
    addToCart: "Add to cart",
    placeOrder: "Place order",
    cartEmpty: "Cart is empty",
    productAdded: "Product added to cart",
    toPrepare: "To prepare",
    inProgress: "In progress",
    documentReference: "Document reference",
    weight: "Weight",
    actualQuantity: "Actual quantity",
    markReady: "Mark as ready",
    markShipped: "Shipped",
    markDelivered: "Delivered",
    startPrep: "Start preparation",
    myCustomers: "My customers",
    myOrders: "My orders",
    commissionTotal: "Total commission",
    pendingApprovals: "Pending approvals",
    approve: "Approve",
    reject: "Reject",
    typeMessage: "Type a message...",
    send: "Send",
    newChat: "New chat",
    noChats: "No chats",
    sentBy: "Sent by",
    // Portal — Agent
    pAgent_overview: "Overview",
    pAgent_kpiOrdersTotal: "Total orders",
    pAgent_kpiCommissionPending: "Pending comm.",
    pAgent_kpiCommissionEarned: "Earned (shipped)",
    pAgent_kpiCommissionCollected: "Collected (paid)",
    pAgent_kpiCommissionEarnedSub: "on shipped/delivered orders",
    pAgent_kpiCommissionCollectedSub: "orders paid by customer",
    pAgent_monthOrders: "Monthly orders",
    pAgent_monthRevenueSub: "revenue",
    pAgent_kpiTotalRevenue: "Total revenue",
    pAgent_subTotalPending: "orders not yet shipped",
    pAgent_lastOrders: "Last orders",
    pAgent_newOrder: "New order",
    pAgent_approvals: "Approvals",
    pAgent_customersList: "Customers",
    pAgent_orderDetail: "Order detail",
    pAgent_unitPrice: "Unit price",
    pAgent_lineTotal: "Line total",
    pAgent_estimatedTotal: "Estimated total",
    pAgent_finalTotal: "Final total",
    pAgent_commissionLine: "Commission",
    pAgent_review: "Review & confirm",
    pAgent_confirmSend: "Confirm & send",
    pAgent_sending: "Sending...",
    pAgent_emptyCart: "Empty cart",
    pCust_yourOrders: "Your orders",
    pCust_yourCart: "Your cart",
    pCust_proceedCheckout: "Proceed to checkout",
    pCust_orderConfirmed: "Order sent",
    pCust_continueShopping: "Continue shopping",
    pCust_repeatOrder: "Repeat order",
    pCust_orderNumber: "Order #",
    pCust_orderDate: "Date",
    pCust_orderTotal: "Total",
    pCust_emptyOrders: "No orders placed",
    pWh_toPrepare: "To prepare",
    pWh_inPreparation: "In preparation",
    pWh_ready: "Ready",
    pWh_shipped: "Shipped",
    pWh_kpiOrdersToday: "Orders today",
    pWh_kpiToPrepareCount: "To prepare",
    pWh_kpiReadyCount: "Ready",
    pWh_kpiShippedCount: "Shipped",
    pWh_documentRef: "DDT reference",
    pWh_actualWeight: "Actual weight",
    pWh_missingItem: "Missing",
    pWh_substitute: "Substitute",
    pWh_scanDDT: "Scan DDT",
    pWh_orderNumber: "Order #",
    pWh_customer: "Customer",
    pWh_save: "Save",
    pWh_markReady: "Mark as ready",
    pWh_markShipped: "Mark as shipped",
    pWh_proposeNew: "Propose new product",
    pWh_extraItem: "Extra product",
    pWh_stats: "Statistics",
    pWh_emptyToPrepare: "No orders to prepare",
    pWh_emptyReady: "No ready orders",
    pWh_emptyShipped: "No shipped orders today",
    pWh_searchOrder: "Search order, customer, agent...",
    pWh_filterStatus: "Filter by status",
    pWh_filterAll: "All orders",
    pWh_filterAgent: "Filter by agent",
    pWh_filterCustomer: "Filter by customer",
    pWh_orderHeader: "Orders to prepare",
    pWh_offerCreate: "New offer",
    pWh_suppliers: "Suppliers",
    pWh_supplierOrders: "Supplier orders",
    pWh_newSupplierOrder: "New supplier order",
    pWh_stockLow: "Low stock",
    pWh_addExtra: "Add extra",
    pWh_substituteWith: "Substitute with",
    pWh_actualQty: "Actual qty",
    pWh_originalQty: "Requested qty",
    pWh_noteForOrder: "Notes for order",
    pWh_qualityNote: "Quality notes",
    pAgent_anagraficaClienti: "Customers",
    pAgent_nClienti: "{n} customers",
    pAgent_newCustomer: "New customer",
    pAgent_editCustomer: "Edit customer",
    pAgent_searchCustomer: "Search by name, VAT, code...",
    pAgent_emptyCustomers: "No customers — click \"New customer\" to start",
    pAgent_orderHistory: "Order history",
    pAgent_pendingApprovals: "Pending approval",
    pAgent_offers: "Special offers",
    pAgent_selectCustomer: "Select a customer",
    pAgent_addProduct: "Add product",
    pAgent_addedToCart: "Added",
    pAgent_noProductFound: "No products",
    pAgent_searchProduct: "Search by code or description...",
    pAgent_specialRequests: "Special requests",
    pAgent_deliveryDate: "Delivery date",
    pAgent_deliveryNotes: "Delivery notes",
    pAgent_orderSent: "Order sent",
    pAgent_orderApproved: "Order approved",
    pAgent_orderRejected: "Order rejected",
    pAgent_loadError: "Load error",
    pAgent_saveError: "Save error",
    pAgent_loginCreated: "Login created",
    pAgent_passwordReset: "Password updated",
    pAgent_passwordTooShort: "Password too short",
    pAgent_credentialsCopied: "Credentials copied",
    pAgent_resetPassword: "Reset password",
    pAgent_legalSeat: "Legal seat",
    pAgent_clearCart: "Clear",
    pAgent_emptyCart: "Empty cart",
    pAgent_items: "Items",
    pAgent_seeProductDetail: "See product details",
    pCust_orderHistory: "Order history",
    pCust_emptyCart: "Empty cart",
    pCust_addedToCart: "Added to cart",
    pCust_clearCart: "Clear cart",
    pCust_sendOrder: "Send order",
    pCust_orderSent: "Order sent",
    pCust_loadError: "Load error",
    pCust_specialRequests: "Special requests",
    pCust_deliveryDate: "Delivery date",
    pCust_deliveryNotes: "Delivery notes",
    pCust_searchProduct: "Search products...",
    pCust_filterCategory: "Category",
    pCust_unitPrice: "Unit price",
    pCust_total: "Total",
    pCust_orderNumber: "Order #",
    pCust_status: "Status",
    common_save: "Save",
    common_cancel: "Cancel",
    common_delete: "Delete",
    common_edit: "Edit",
    common_close: "Close",
    common_add: "Add",
    common_back: "Back",
    common_next: "Next",
    common_confirm: "Confirm",
    common_search: "Search",
    common_loading: "Loading...",
    common_saving: "Saving...",
    common_sending: "Sending...",
    common_yes: "Yes",
    common_no: "No",
    common_error: "Error",
    common_success: "Done",
    common_required: "Required field",
    common_notFound: "Not found",
    common_unknown: "Unknown",
    settings: "Settings",
    settingsGeneral: "Company info",
    settingsCurrency: "Currency & Exchange",
    settingsPreview: "Preview",
    settingsSaved: "Settings saved",
    settingsSaveError: "Save error",
    companyName: "Company name",
    country: "Country (code)",
    vatNumber: "VAT number",
    defaultLang: "Default language",
    address: "Address",
    currencyCode: "Currency code",
    currencySymbol: "Symbol",
    exchangeRate: "Exchange rate vs EUR",
    exchangeRateHint: "E.g. 1 EUR = 4.30 PLN → enter 4.30. Set 1.0 if currency is EUR.",
    defaultVatRate: "Default VAT (e.g. 0.10 = 10%)",
    priceExample: "Price example (100)",
    convertedToEUR: "Converted to EUR",
    exampleVat: "VAT on 100",
    displayCurrencyMode: "Calculation / display mode",
    nativeCurrency: "Native currency",
    nativeCurrencyHint: "All calculations and totals in company currency",
    eurCurrency: "Euro (converted)",
    eurCurrencyHint: "Convert everything to EUR using the configured rate",
    alreadyEur: "Company already in EUR",
  },
  pl: {
    products: "Produkty", categories: "Kategorie", agents: "Agenci", pricelists: "Typy cennika",
    generator: "Generuj cennik", code: "Kod", description: "Opis", price: "Cena",
    basePrice: "Cena bazowa", availability: "Dost.", available: "Dostępny",
    week: "Tydzień", year: "Rok", search: "Szukaj...", save: "Zapisz", cancel: "Anuluj",
    download: "Pobierz", language: "Język", columns: "Kolumny", show: "Pokaż", hide: "Ukryj",
    name: "Nazwa", nameEn: "Nazwa (EN)", descEn: "Opis (EN)", order: "Kolejność",
    login: "Zaloguj", logout: "Wyloguj", new: "Nowy", edit: "Edytuj", delete: "Usuń",
    import: "Importuj", generatePdf: "Generuj PDF",
    company: "Firma", changeCompany: "Zmień firmę", dashboard: "Pulpit",
    orders: "Zamówienia", customers: "Klienci", suppliers: "Dostawcy", offers: "Oferty",
    supplierOrders: "Zamówienia dostawców", statsProducts: "Statystyki produktów",
    pendingApproval: "Do zatwierdzenia", chat: "Czat", warehouse: "Magazyn",
    customer: "Klient", admin: "Administrator", agent: "Agent",
    total: "Razem", subtotal: "Kwota netto", vat: "VAT", quantity: "Ilość", unit: "J.m.",
    status: "Status", actions: "Akcje", details: "Szczegóły", preview: "Podgląd",
    addItem: "Dodaj pozycję", outOfListino: "Poza cennikiem", inListino: "W cenniku",
    confirm: "Potwierdź", yes: "Tak", no: "Nie", close: "Zamknij", back: "Wstecz",
    loading: "Ładowanie...", noResults: "Brak wyników",
    statusPending: "Do przygotowania", statusInPrep: "W przygotowaniu", statusReady: "Gotowe",
    statusShipped: "Wysłane", statusDelivered: "Dostarczone", statusCancelled: "Anulowane",
    statusPendingAgent: "Oczekuje zatwierdzenia", statusCompleted: "Zakończone", statusPaid: "Opłacone",
    statusConfirmed: "Potwierdzone",
    itemsCol: "Pozycje",
    newOrder: "Nowe zamówienie",
    biTitle: "Business Intelligence",
    biSubtitle: "Przegląd zamówień, wysyłek, obrotu i prowizji",
    biKpiOrders: "Wszystkie zamówienia", biKpiTaxable: "Kwota netto", biKpiShipped: "Wysłane — Wartość",
    biKpiCommissions: "Łączne prowizje",
    biKpiShippedDesc: "wysłane · oczekujące", biKpiTaxableDesc: "z VAT",
    biKpiConfirmedDesc: "potwierdzone i wysłane", biKpiCommissionsDesc: "do wypłaty/naliczone",
    biDailyTrend: "Trend dzienny",
    biTopCustomers: "Najlepsi klienci wg obrotu",
    biTopAgents: "Agenci",
    biTopProducts: "Najczęściej wysyłane produkty (wg ilości)",
    biDailyDetail: "Szczegóły dzienne",
    biColDay: "Dzień", biColOrders: "Zamówienia", biColTaxable: "Netto",
    biColVat: "VAT", biColTotal: "Razem", biColCommission: "Prow.",
    biPeriodThisMonth: "Bieżący miesiąc", biPeriodLast30: "Ostatnie 30 dni",
    biPeriodLast7: "Ostatnie 7 dni", biPeriodToday: "Dziś", biPeriodAll: "Wszystko",
    allProducts: "Wszystkie produkty", allCategories: "Wszystkie kategorie",
    onlyInListino: "Tylko w cenniku", onlyOutOfListino: "Tylko poza cennikiem",
    category: "Kategoria", note: "Notatki", importExcel: "Importuj z Excel",
    uploadFile: "Załaduj plik Excel (.xlsx)", finalPrice: "Cena końcowa",
    noAgents: "Brak agentów", noPricelistType: "Brak skonfigurowanych typów cennika",
    deleteProduct: "Usuń produkt",
    ordersList: "Zamówienia", customerCol: "Klient", agentCol: "Agent",
    dateCol: "Data", totalCol: "Razem",
    email: "Email", password: "Hasło", emailPh: "twoj@email.com",
    selectRole: "Wybierz swoją rolę", welcome: "Witamy",
    address: "Adres", phone: "Telefon", contact: "Kontakt",
    vatNumber: "NIP", taxCode: "Kod podatkowy",
    accessCode: "Kod dostępu", commission: "Prowizja",
    markup: "Narzut", discount: "Rabat",
    free: "Gratis", italian: "Włoski", foreign: "Zagraniczny",
    submit: "Wyślij", create: "Utwórz", update: "Aktualizuj",
    none: "Brak", all: "Wszystkie", active: "Aktywny", inactive: "Nieaktywny",
    type: "Typ",
    companySettings: "Ustawienia firmy",
    currencyAndExchange: "Waluta i kurs",
    currency: "Waluta", symbol: "Symbol",
    exchangeRate: "Ręczny kurs wymiany",
    exchangeRateHint: "Ustaw ręcznie, aby uniknąć wahań kursów rynkowych",
    displayInEur: "Pokaż ceny w EUR",
    displayInEurHint: "Konwersja wyłącznie wyświetlania. Ceny w bazie pozostają w walucie lokalnej.",
    preview: "Podgląd",
    backToOrders: "Powrót do zamówień",
    profile: "Profil",
    settings: "Ustawienia",
    notifications: "Powiadomienia",
    welcome2: "Witamy z powrotem",
    overview: "Przegląd",
    recentOrders: "Ostatnie zamówienia",
    catalog: "Katalog",
    cart: "Koszyk",
    yourOrders: "Twoje zamówienia",
    profile2: "Profil",
    repeat: "Powtórz",
    partial: "Częściowe",
    deliveryAddress: "Adres dostawy",
    deliveryNotes: "Uwagi do dostawy",
    specialRequests: "Specjalne życzenia",
    addToCart: "Dodaj do koszyka",
    placeOrder: "Wyślij zamówienie",
    cartEmpty: "Koszyk jest pusty",
    productAdded: "Produkt dodany do koszyka",
    toPrepare: "Do przygotowania",
    inProgress: "W toku",
    documentReference: "Numer dokumentu",
    weight: "Waga",
    actualQuantity: "Rzeczywista ilość",
    markReady: "Oznacz jako gotowe",
    markShipped: "Wysłane",
    markDelivered: "Dostarczone",
    startPrep: "Rozpocznij przygotowanie",
    myCustomers: "Moi klienci",
    myOrders: "Moje zamówienia",
    commissionTotal: "Łączna prowizja",
    pendingApprovals: "Oczekujące zatwierdzenia",
    approve: "Zatwierdź",
    reject: "Odrzuć",
    typeMessage: "Napisz wiadomość...",
    send: "Wyślij",
    newChat: "Nowy czat",
    noChats: "Brak czatów",
    sentBy: "Wysłane przez",
    // Portal — Agent
    pAgent_overview: "Przegląd",
    pAgent_kpiOrdersTotal: "Wszystkie zamówienia",
    pAgent_kpiCommissionPending: "Prowizja oczekująca",
    pAgent_kpiCommissionEarned: "Naliczona (wysłane)",
    pAgent_kpiCommissionCollected: "Odebrana (opłacone)",
    pAgent_kpiCommissionEarnedSub: "z wysłanych/dostarczonych",
    pAgent_kpiCommissionCollectedSub: "zamówienia opłacone przez klienta",
    pAgent_monthOrders: "Zamówienia miesięczne",
    pAgent_monthRevenueSub: "obrót",
    pAgent_kpiTotalRevenue: "Całkowity obrót",
    pAgent_subTotalPending: "zamówienia jeszcze nie wysłane",
    pAgent_lastOrders: "Ostatnie zamówienia",
    pAgent_newOrder: "Nowe zamówienie",
    pAgent_approvals: "Zatwierdzenia",
    pAgent_customersList: "Klienci",
    pAgent_orderDetail: "Szczegóły zamówienia",
    pAgent_unitPrice: "Cena jedn.",
    pAgent_lineTotal: "Wartość pozycji",
    pAgent_estimatedTotal: "Szac. razem",
    pAgent_finalTotal: "Razem (finalny)",
    pAgent_commissionLine: "Prowizja",
    pAgent_review: "Sprawdź i potwierdź",
    pAgent_confirmSend: "Potwierdź i wyślij",
    pAgent_sending: "Wysyłanie...",
    pAgent_emptyCart: "Pusty koszyk",
    pCust_yourOrders: "Twoje zamówienia",
    pCust_yourCart: "Twój koszyk",
    pCust_proceedCheckout: "Przejdź do kasy",
    pCust_orderConfirmed: "Zamówienie wysłane",
    pCust_continueShopping: "Kontynuuj zakupy",
    pCust_repeatOrder: "Powtórz zamówienie",
    pCust_orderNumber: "Nr zamówienia",
    pCust_orderDate: "Data",
    pCust_orderTotal: "Razem",
    pCust_emptyOrders: "Brak zamówień",
    pWh_toPrepare: "Do przygotowania",
    pWh_inPreparation: "W przygotowaniu",
    pWh_ready: "Gotowe",
    pWh_shipped: "Wysłane",
    pWh_kpiOrdersToday: "Dzisiejsze zamówienia",
    pWh_kpiToPrepareCount: "Do przygotowania",
    pWh_kpiReadyCount: "Gotowe",
    pWh_kpiShippedCount: "Wysłane",
    pWh_documentRef: "Nr WZ",
    pWh_actualWeight: "Waga rzeczywista",
    pWh_missingItem: "Brak",
    pWh_substitute: "Zamień",
    pWh_scanDDT: "Skanuj WZ",
    pWh_orderNumber: "Zamówienie nr",
    pWh_customer: "Klient",
    pWh_save: "Zapisz",
    pWh_markReady: "Oznacz jako gotowe",
    pWh_markShipped: "Oznacz jako wysłane",
    pWh_proposeNew: "Zaproponuj nowy produkt",
    pWh_extraItem: "Produkt dodatkowy",
    pWh_stats: "Statystyki",
    pWh_emptyToPrepare: "Brak zamówień do przygotowania",
    pWh_emptyReady: "Brak gotowych zamówień",
    pWh_emptyShipped: "Brak dzisiejszych wysyłek",
    pWh_searchOrder: "Szukaj zamówienia, klienta, agenta...",
    pWh_filterStatus: "Filtruj po statusie",
    pWh_filterAll: "Wszystkie zamówienia",
    pWh_filterAgent: "Filtruj po agencie",
    pWh_filterCustomer: "Filtruj po kliencie",
    pWh_orderHeader: "Zamówienia do przygotowania",
    pWh_offerCreate: "Nowa oferta",
    pWh_suppliers: "Dostawcy",
    pWh_supplierOrders: "Zamówienia dostawców",
    pWh_newSupplierOrder: "Nowe zamówienie do dostawcy",
    pWh_stockLow: "Niski stan magazynu",
    pWh_addExtra: "Dodaj dodatek",
    pWh_substituteWith: "Zamień na",
    pWh_actualQty: "Faktyczna ilość",
    pWh_originalQty: "Zamówiona ilość",
    pWh_noteForOrder: "Notatki do zamówienia",
    pWh_qualityNote: "Notatki jakościowe",
    pAgent_anagraficaClienti: "Klienci",
    pAgent_nClienti: "{n} klientów",
    pAgent_newCustomer: "Nowy klient",
    pAgent_editCustomer: "Edytuj klienta",
    pAgent_searchCustomer: "Szukaj po nazwie, NIP, kodzie...",
    pAgent_emptyCustomers: "Brak klientów — kliknij \"Nowy klient\", aby rozpocząć",
    pAgent_orderHistory: "Historia zamówień",
    pAgent_pendingApprovals: "Do zatwierdzenia",
    pAgent_offers: "Promocje",
    pAgent_selectCustomer: "Wybierz klienta",
    pAgent_addProduct: "Dodaj produkt",
    pAgent_addedToCart: "Dodano",
    pAgent_noProductFound: "Brak produktów",
    pAgent_searchProduct: "Szukaj po kodzie lub opisie...",
    pAgent_specialRequests: "Specjalne wymagania",
    pAgent_deliveryDate: "Data dostawy",
    pAgent_deliveryNotes: "Uwagi do dostawy",
    pAgent_orderSent: "Zamówienie wysłane",
    pAgent_orderApproved: "Zamówienie zatwierdzone",
    pAgent_orderRejected: "Zamówienie odrzucone",
    pAgent_loadError: "Błąd wczytywania",
    pAgent_saveError: "Błąd zapisu",
    pAgent_loginCreated: "Login utworzony",
    pAgent_passwordReset: "Hasło zaktualizowane",
    pAgent_passwordTooShort: "Hasło zbyt krótkie",
    pAgent_credentialsCopied: "Dane skopiowane",
    pAgent_resetPassword: "Reset hasła",
    pAgent_legalSeat: "Siedziba",
    pAgent_clearCart: "Wyczyść",
    pAgent_emptyCart: "Pusty koszyk",
    pAgent_items: "Pozycje",
    pAgent_seeProductDetail: "Zobacz szczegóły produktu",
    pCust_orderHistory: "Historia zamówień",
    pCust_emptyCart: "Pusty koszyk",
    pCust_addedToCart: "Dodano do koszyka",
    pCust_clearCart: "Opróżnij koszyk",
    pCust_sendOrder: "Wyślij zamówienie",
    pCust_orderSent: "Zamówienie wysłane",
    pCust_loadError: "Błąd wczytywania",
    pCust_specialRequests: "Wymagania specjalne",
    pCust_deliveryDate: "Data dostawy",
    pCust_deliveryNotes: "Uwagi do dostawy",
    pCust_searchProduct: "Szukaj produktów...",
    pCust_filterCategory: "Kategoria",
    pCust_unitPrice: "Cena jedn.",
    pCust_total: "Razem",
    pCust_orderNumber: "Nr zamówienia",
    pCust_status: "Status",
    common_save: "Zapisz",
    common_cancel: "Anuluj",
    common_delete: "Usuń",
    common_edit: "Edytuj",
    common_close: "Zamknij",
    common_add: "Dodaj",
    common_back: "Wstecz",
    common_next: "Dalej",
    common_confirm: "Potwierdź",
    common_search: "Szukaj",
    common_loading: "Wczytywanie...",
    common_saving: "Zapisywanie...",
    common_sending: "Wysyłanie...",
    common_yes: "Tak",
    common_no: "Nie",
    common_error: "Błąd",
    common_success: "Sukces",
    common_required: "Pole wymagane",
    common_notFound: "Nie znaleziono",
    common_unknown: "Nieznany",
    settings: "Ustawienia",
    settingsGeneral: "Dane firmy",
    settingsCurrency: "Waluta i kurs",
    settingsPreview: "Podgląd",
    settingsSaved: "Ustawienia zapisane",
    settingsSaveError: "Błąd zapisu",
    companyName: "Nazwa firmy",
    country: "Kraj (kod)",
    vatNumber: "NIP / VAT",
    defaultLang: "Język domyślny",
    address: "Adres",
    currencyCode: "Kod waluty",
    currencySymbol: "Symbol",
    exchangeRate: "Kurs do EUR",
    exchangeRateHint: "Np. 1 EUR = 4.30 PLN → wpisz 4.30. Wpisz 1.0 jeśli walutą jest EUR.",
    defaultVatRate: "Domyślny VAT (np. 0.10 = 10%)",
    priceExample: "Przykład ceny (100)",
    convertedToEUR: "Przeliczone na EUR",
    exampleVat: "VAT od 100",
    displayCurrencyMode: "Tryb kalkulacji / wyświetlania",
    nativeCurrency: "Waluta lokalna",
    nativeCurrencyHint: "Wszystkie obliczenia w walucie firmy",
    eurCurrency: "Euro (przeliczone)",
    eurCurrencyHint: "Przelicz wszystko na EUR według ustawionego kursu",
    alreadyEur: "Firma już w EUR",
  },
};

export const LangProvider = ({ children }) => {
  const initialLang = () => {
    const stored = localStorage.getItem("lang");
    if (stored && ["it", "en", "pl"].includes(stored)) return stored;
    try {
      const userRaw = localStorage.getItem("user");
      if (userRaw) {
        const u = JSON.parse(userRaw);
        if (u?.company_id === "giotto-polska") return "pl";
      }
    } catch (e) { /* silently ignore non-critical fetch errors */ console.debug(e); }
    return "it";
  };
  const [lang, setLang] = useState(initialLang);
  const setLanguage = (l) => { localStorage.setItem("lang", l); setLang(l); };

  useEffect(() => {
    const fromStorage = localStorage.getItem("lang");
    if (fromStorage) return;
    try {
      const userRaw = localStorage.getItem("user");
      if (!userRaw) return;
      const u = JSON.parse(userRaw);
      if (u?.company_id === "giotto-polska" && lang !== "pl") setLang("pl");
      if (u?.company_id === "giotto-italia" && lang !== "it") setLang("it");
    } catch (e) { /* silently ignore non-critical fetch errors */ console.debug(e); }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const t = T[lang] || T.it;
  return <LangContext.Provider value={{ lang, setLang: setLanguage, t, available: ["it", "en", "pl"] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
